export const CALL_CENTER_MIN_TASK_MS = 20 * 60 * 1000;
export const CALL_CENTER_NUDGE_MS = 5 * 60 * 1000;
